module.exports = __webpack_public_path__ + "images/d22d30c20a0e00c545bf08fe4851b7f720874b98187b689698a4062d23a4e10e.svg";